<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Oferta comercial laboratorio: {{ nombreLab }}</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Panel de control</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content align-items-center gap-2">
    <button class="btn btn-secondary" type="button" (click)="abrirAgregar(mdlAgregar)">Agregar</button>
    <button class="btn btn-outline-secondary" type="button" (click)="volver()">Volver</button>
  </div>
</div>

<div class="card">
  <div class="card-body">
    @if (cargando) {
      <p class="text-center mb-0">Cargando...</p>
    }

    @if (!cargando) {
      <div class="table-responsive">
        <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext">
          <thead>
            <tr>
              <th>#</th>
              <th>Código</th>
              <th>Nombre</th>
              <th>Precio</th>
              <th>Fecha de registro</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            @for (oferta of ofertas; track oferta; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ oferta.CODN_EXAM }}</td>
                <td>{{ oferta.NOM_EXAM }}</td>
                <td>{{ oferta.AMOUNT_EXAM | currency:'USD':'symbol':'1.2-2' }}</td>
                <td>{{ oferta.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>
                  <div class="btn-group">
                    <button class="btn btn-warning btn-sm" type="button" (click)="abrirEditar(mdlEditar, oferta)">
                      <i class="zmdi zmdi-edit text-white"></i>
                    </button>
                    <button class="btn btn-danger btn-sm" type="button" (click)="eliminarExamen(oferta)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<ng-template #mdlAgregar let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Agregar Exámen</h6>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-2">
      <label><strong>Código</strong></label>
      <input type="text" class="form-control" [(ngModel)]="nuevoCodigo">
    </div>
    <div class="form-group mb-2">
      <label><strong>Nombre</strong></label>
      <input type="text" class="form-control" [(ngModel)]="nuevoExamen">
    </div>
    <div class="form-group">
      <label><strong>Valor</strong></label>
      <input type="number" step="0.01" class="form-control" [(ngModel)]="nuevoValor">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Salir</button>
    <button type="button" class="btn btn-secondary" (click)="guardarExamen()" [disabled]="guardando">Guardar</button>
  </div>
</ng-template>

<ng-template #mdlEditar let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Editar Exámen</h6>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-2">
      <label><strong>Código</strong></label>
      <input type="text" class="form-control" [(ngModel)]="editarCodigo">
    </div>
    <div class="form-group mb-2">
      <label><strong>Nombre</strong></label>
      <input type="text" class="form-control" [(ngModel)]="editarExamen">
    </div>
    <div class="form-group">
      <label><strong>Valor</strong></label>
      <input type="number" step="0.01" class="form-control" [(ngModel)]="editarValor">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Salir</button>
    <button type="button" class="btn btn-secondary" (click)="actualizarExamen()" [disabled]="guardando">Guardar cambios</button>
  </div>
</ng-template>
